<form class="vgs-form">
  <div class="field" *ngIf="!!SenderCardNr">
    <label>{{ SenderCardNr.label | translate }}</label>
    <div id="{{ SenderCardNr.id }}" class="form-field"></div>
    <h6
      class="err-msg"
      *ngIf="
        CardNumberFormState?.isinvalid &&
        CardNumberFormState?.isempty &&
        CardNumberFormState?.isdirty
      "
    >
      {{ "P2P.SENDERBLOCK.ERR.REQ.CARDNR" | translate }}
    </h6>
    <h6
      class="err-msg"
      *ngIf="
        CardNumberFormState?.checkedbin !== null &&
        CardNumberFormState?.checkedbin === false &&
        CardNumberFormState?.hasbin
      "
    >
      {{ "P2P.SENDERBLOCK.ERR.CHECKEDBIN" | translate }}
    </h6>
    <h6
      class="err-msg"
      *ngIf="
        CardNumberFormState?.isnotvalidcardtype && !CardNumberFormState?.isempty
      "
    >
      {{ "P2P.SENDERBLOCK.ERR.INVALIDTYPE.CARDNR" | translate }}
    </h6>
    <h6
      class="err-msg"
      *ngIf="
        !CardNumberFormState?.isnotvalidcardtype &&
        CardNumberFormState?.isinvalid &&
        !CardNumberFormState?.isempty
      "
    >
      {{ "P2P.SENDERBLOCK.ERR.INVALID.CARDNR" | translate }}
    </h6>
  </div>
  <div class="form-field-group">
    <div class="field" *ngIf="!!SenderCardExpDate">
      <label>{{ SenderCardExpDate.label | translate }}</label>
      <div id="{{ SenderCardExpDate.id }}" class="form-field"></div>
      <h6
        class="err-msg"
        *ngIf="ExpDateFormState?.isinvalid && !ExpDateFormState?.isempty"
      >
        {{ "P2P.SENDERBLOCK.ERR.REQ.CARDEXPDATE" | translate }}
      </h6>
      <h6
        class="err-msg"
        *ngIf="
          ExpDateFormState?.isinvalid &&
          ExpDateFormState?.isempty &&
          ExpDateFormState?.isdirty
        "
      >
        {{ "P2P.SENDERBLOCK.ERR.REQ.CARDEXPDATE" | translate }}
      </h6>
    </div>
    <div class="field" *ngIf="!!SenderCardCVV">
      <label>{{ SenderCardCVV.label | translate }}</label>
      <div id="{{ SenderCardCVV.id }}" class="form-field"></div>
      <h6
        class="err-msg"
        *ngIf="CVVFormState?.isinvalid && !CVVFormState?.isempty"
      >
        {{ "P2P.SENDERBLOCK.ERR.REQ.CVV" | translate }}
      </h6>
      <h6
        class="err-msg"
        *ngIf="
          CVVFormState?.isinvalid &&
          CVVFormState?.isempty &&
          CVVFormState?.isdirty
        "
      >
        {{ "P2P.SENDERBLOCK.ERR.REQ.CVV" | translate }}
      </h6>
    </div>
  </div>
</form>
